import { createStore } from 'vuex'
import axios from 'axios'

import sentiments from './modules/sentiments'
import payments from './modules/payments'
import users from './modules/users'
import orders from './modules/orders'

export default createStore({
  state: {
    sidebarVisible: '',
    sidebarUnfoldable: false,
    api: 'https://app.sentiment.com.pl/api',
    apiToken: '',
    isAuthenticated: false,
    user: {
      id: 0,
      email: '',
      name: '',
    },
    subscriptions: [],
    subscription: {
      id: 0,
      name: '',
      price: 0.0,
      days: 0,
      active: false,
    },
  },
  mutations: {
    toggleSidebar(state) {
      state.sidebarVisible = !state.sidebarVisible
    },
    toggleUnfoldable(state) {
      state.sidebarUnfoldable = !state.sidebarUnfoldable
    },
    updateSidebarVisible(state, payload) {
      state.sidebarVisible = payload.value
    },
    setToken(state, payload) {
      state.apiToken = payload
    },
    setAuth(state, payload) {
      state.isAuthenticated = payload
    },
    setUser(state, payload) {
      state.user = payload
    },
    setSubscriptions(state, payload) {
      state.subscriptions = payload
    },
    setSubscription(state, payload) {
      state.subscription = payload
    },
  },
  actions: {
    async login({ state, commit }, { email, password }) {
      const response = await axios.post(state.api + '/login', {
        email,
        password,
      })

      commit('setAuth', true)
      commit('setToken', response.data.token)

      localStorage.setItem('apiToken', response.data.token)
    },
    async logout({ commit }) {
      localStorage.removeItem('apiToken')

      commit('setToken', '')
      commit('setAuth', false)
    },
    async user({ state, commit }) {
      const response = await axios.get(state.api + '/me', {
        headers: {
          Authorization: 'Bearer ' + state.apiToken,
        },
      })

      commit('setAuth', true)
      commit('setUser', response.data)
    },
    async getSubscriptions({ state, commit }) {
      const response = await axios.get(state.api + '/subscriptions', {
        headers: {
          Authorization: 'Bearer ' + state.apiToken,
        },
      })

      commit('setSubscriptions', response.data)
    },
    async storeSub({ state }, payload) {
      await axios.post(state.api + '/subscriptions', payload, {
        headers: {
          Authorization: 'Bearer ' + state.apiToken,
        },
      })
    },
    async showSub({ state, commit }, payload) {
      const response = await axios.get(
        `${state.api}/subscriptions/${payload.id}`,
        {
          headers: {
            Authorization: 'Bearer ' + state.apiToken,
          },
        },
      )

      commit('setSubscription', response.data)
    },
    async updateSub({ state }) {
      await axios.put(
        `${state.api}/subscriptions/${state.subscription.id}`,
        state.subscription,
        {
          headers: {
            Authorization: 'Bearer ' + state.apiToken,
          },
        },
      )
    },
  },
  getters: {
    isAuthenticated: (state) => state.isAuthenticated,
    token: (state) => state.token,
    user: (state) => state.user,
    getSubscriptions: (state) => state.subscriptions,
    getSubscription: (state) => state.subscription,
  },
  modules: {
    sentiments,
    users,
    payments,
    orders,
  },
})
